/** Inline SVG only — no external icon library or image requests (spec §UI). */
export function EmptyState({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center gap-3 py-12 text-center text-stone-500">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M3 7l3-4h12l3 4" />
        <path d="M9 11h6" />
      </svg>
      <p>{message}</p>
    </div>
  );
}
